import constants from '@/app-configs/constants'

export default [
  {
    title: 'DEBTIA_EVENT_LOGS',
    icon: 'MessageCircleIcon',
    route: 'event-logs',
    action: constants.action.permissionEventLogsList,
    resource: constants.resource.user,
  },
]
